export default __webpack_public_path__ + "static/media/nudge-prompt-to-desktop.4ef596e3.png";